import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-sub-acct',
  templateUrl: './sub-acct.component.html',
  styleUrls: ['./sub-acct.component.css']
})
export class SubAcctComponent implements OnInit {
  // private dp = [];
  // displayedColumns = ['sub_acct_name', 'acct_number', 'edit', 'del'];
  // dataSource = new MatTableDataSource(this.dp);
  // @ViewChild(MatSort) sort: MatSort;

  myControl = new FormControl();
  list = [];
  acctList = [];
  // emps = [];
  ccs = [];
  // acctTypes = [];
  // mainAccts = [];
  taxes = [];
  level_num;
  parent_of_parent = '0';
  acctDetail = '';
  // months = [];
  // days = [];
  // acct_base = [];
  // acct_type_name;
  // main_acct_name;

  model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0', 'acct_type_no': '0', 'main_acct_no': '0', 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': '', 'acct_level': '0', 'is_leaf': '0', 'is_cc': '0',
    'tax_acct': '0', 'emp_no': '0', 'cc_no': '0', 'key': 'sub_acct_id', 'flag': 'new', 'comment': '',
    'auto_set': '0', 'set_type': 'count'
  };

  date_model = {
    'base_date': new Date(this.applicationConstants.business_cycle.start_date),
    'base_type': 'creditor', 'has_base': '0'
  };

  base_model = {
    'table_name': 'acct_base', 'acct_number': '0', 'main_acct_no': '0', 'base_date': '',
    'acct_type_no': '0', 'key': 'baseline_id', 'flag': 'new', 'baseline_amount': '0', 'comment': ''
  };

  Success_Msg; Error_Msg;
  Belong_To_Msg; Acct_No_Msg;
  Acct_Name_Msg; Acct_No_Exist;
  Level_Num_Msg; Level_Num_Msg2;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private queryList: QueryList,
    private dialogRef: MatDialogRef<SubAcctComponent>, @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Belong_To_Msg').subscribe((res: string) => {
      this.Belong_To_Msg = res;
    });

    translate.get('Acct_No_Msg').subscribe((res: string) => {
      this.Acct_No_Msg = res;
    });

    translate.get('Acct_Name_Msg').subscribe((res: string) => {
      this.Acct_Name_Msg = res;
    });

    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });

    translate.get('Level_Num_Msg').subscribe((res: string) => {
      this.Level_Num_Msg = res;
    });

    translate.get('Level_Num_Msg2').subscribe((res: string) => {
      this.Level_Num_Msg2 = res;
    });
  }

  ngOnInit() {
    this.list = [];
    let obj;

    // get not leaf sub accts
    let parent_acct = "";
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctList = data.data['list'];
      });
    // this.acctList = this.utils.getAcctList(parent_acct, false);
    // console.log(this.acctList);

    this.level_num = this.utils.getParamValue('level_num');
    /////////////////// get all cc /////////////////////////
    let query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.ccs = data.data['list'];
        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.ccs.unshift(costObj);
      });

    ////////////////////////////// Get all taxes ///////////////////////////
    query = this.queryList.all_tax_types;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.taxes = data.data['list'];
        //console.log(this.taxes);

      });

    if (this.dialog_data != null && this.dialog_data.sub_acct_id != undefined) {
      query = this.queryList.all_subAcct + " AND `sub_acct_id` = '" + this.dialog_data.sub_acct_id + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let sub_acct = data.data['list'][0];
          this.model['sub_acct_id'] = sub_acct['sub_acct_id'];
          this.model['acct_number'] = sub_acct['acct_number'];
          this.model['acct_type_no'] = sub_acct['acct_type_no'];
          this.model['main_acct_no'] = sub_acct['main_acct_no'];
          this.model['sub_acct_name'] = sub_acct['sub_acct_name'];
          this.model['sub_acct_name_en'] = sub_acct['sub_acct_name_en'];
          this.model['parent_acct'] = sub_acct['parent_acct'];
          this.model['acct_level'] = sub_acct['acct_level'];
          this.model['is_leaf'] = sub_acct['is_leaf'];
          this.model['is_cc'] = sub_acct['is_cc'];
          this.model['tax_acct'] = sub_acct['tax_acct'];
          this.model['cc_no'] = sub_acct['cc_no'];
          this.model['comment'] = sub_acct['comment'];
          this.model['flag'] = 'update';

          (document.getElementById('search_value_0') as HTMLInputElement).disabled = (sub_acct['parent_acct'] == '0');

          // get parent acct detail
          if (sub_acct['parent_acct'] != '0') {
            query = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let parent_acct = data.data['list'][0];
                console.log(parent_acct);
                this.parent_of_parent = parent_acct['parent_acct'];
                // console.log((document.getElementById('parent_acct') as HTMLInputElement));
                this.acctDetail = sub_acct['parent_acct'] + ' - ' +
                  parent_acct['sub_acct_name'] + ' - ' + parent_acct['sub_acct_name_en'];
              });
          }


          if (this.model['is_leaf'] == '1') {
            console.log(this.model);
            this.date_model['has_base'] = '1';
            (document.getElementById('is_leaf') as HTMLInputElement).checked = true;

          }
          else {
            console.log(this.model);

            // check if it has base
            query = "SELECT * FROM `acct_base` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
            obj = { cmd: 'getList', query: query };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let result = data.data['list'];
                if (result.length > 0)
                  this.date_model['has_base'] = '1';
              });

            // check if it is parent
            obj = { cmd: 'getAccountList', parent_acct: this.model['acct_number'], add_leaf: true };
            this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let list = data.data['list'];
                (document.getElementById('is_leaf') as HTMLInputElement).disabled = (this.parent_of_parent == '0' || list.length > 0);
              });
          }

        });
    }
  }

  onChangeSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.model['parent_acct'] = "";

      if (acct_number != '') {
        this.model['parent_acct'] = acct_number;

        this.model['acct_level'] = "0";

        var element;
        for (let index = 0; index < this.acctList.length; index++) {
          element = this.acctList[index];
          if (element.acct_number == this.model['parent_acct']) {
            this.parent_of_parent = element.parent_acct;
            this.model['acct_level'] = String(Number(element.acct_level) + 1);
            this.model['acct_type_no'] = element.acct_type_no;

            if (this.parent_of_parent == '0')
              this.model['main_acct_no'] = this.model['acct_number'];
            else
              this.model['main_acct_no'] = element.main_acct_no;

            (document.getElementById('is_leaf') as HTMLInputElement).disabled = (this.parent_of_parent == '0');
            break;
          }
        }
      }
      else
        this.model['parent_acct'] = parent_acct;


      if (this.model['sub_acct_id'] == '0') {
        this.model['acct_number'] = "";

        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
          this.model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = data.data['list'][0]['acct_number'];
            if (result == '0')
              this.model['acct_number'] = this.model['parent_acct'] + "001";
            else {
              if (result.indexOf(this.model['parent_acct']) != -1) {
                result = result.substring(result.indexOf(this.model['parent_acct']) + (this.model['parent_acct']).length);
                console.log('result: ' + result);
                result = String(Number(result) + 1);
                if (Number(result) < 10)
                  result = '00' + result;
                else if (Number(result) < 100)
                  result = '0' + result;
                  
                this.model['acct_number'] = this.model['parent_acct'] + result;
              }
              else
                this.model['acct_number'] = String(Number(result) + 1);
            }
              // this.model['acct_number'] = String(result + 1);
          });
      }

    }
  }

  changeAcctNumber() {
    if (this.model['acct_number'] == "" && this.model['parent_acct'] != "")
      this.onChangeSearch("", this.model['parent_acct']);
  }

  changeIsAccount() {
    this.model['is_leaf'] = ((document.getElementById('is_leaf') as HTMLInputElement).checked ? '1' : '0');
    this.model['is_cc'] = this.model['is_leaf'];
  }

  add() {
    if (this.model['parent_acct'] == '') {
      alert(this.Belong_To_Msg);
      return;
    }

    if (this.model['acct_number'] == '') {
      alert(this.Acct_No_Msg);
      return;
    }

    if (this.model['sub_acct_name'] == '' || this.model['sub_acct_name_en'] == '') {
      alert(this.Acct_Name_Msg);
      return;
    }

    if (Number(this.model['acct_level']) == Number(this.level_num) && this.model['is_leaf'] == '0') {
      alert(this.Level_Num_Msg2);
      return;
    }

    if (Number(this.model['acct_level']) > Number(this.level_num)) {
      alert(this.Level_Num_Msg);
      return;
    }

    let values = [];
    values.push(this.model);

    if (this.model['is_leaf'] == '1' && this.date_model['has_base'] == '0') {
      //add acct base
      this.base_model['base_date'] = this.date_model['base_date'].getFullYear() + '-' +
      (this.date_model['base_date'].getMonth() + 1) + '-' + this.date_model['base_date'].getDate() +
      " 00:00:00"; 
      // this.date_model['base_date'].getFullYear() + '-01-01 00:00:00';
      // ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

      this.base_model['acct_number'] = this.model['acct_number'];
      this.base_model['acct_type_no'] = this.model['acct_type_no'];
      this.base_model['main_acct_no'] = this.model['main_acct_no'];

      if (this.date_model['base_type'] == 'creditor' && this.base_model['baseline_amount'] != '0')
        this.base_model['baseline_amount'] = '-' + this.base_model['baseline_amount'];

      values.push(this.base_model);
    }

    let obj;
    if (this.model['sub_acct_id'] == '0') {
      let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let result = data.data['list'];
          if (result.length > 0)
            alert(this.Acct_No_Exist);
          else {
            // add account
            obj = { cmd: 'add', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.dialog_data = { 'op_type': 'success' };
                  this.dialogRef.close(this.dialog_data);

                  // if (this.model['main_acct_no'] == this.applicationConstants.main_acct_config['customer'])
                  //   this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
                }
                else
                  alert(this.Error_Msg);

              });
          }
        });
    }
    else {
      // update account
      obj = { cmd: 'updateAdv', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);

            // if (this.model['main_acct_no'] == this.applicationConstants.main_acct_config['customer'])
            //   this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
          }
          else
            alert(this.Error_Msg);

        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
